// extracted by mini-css-extract-plugin
module.exports = {"userAvatar":"yW+-H","companyAvatar":"hJ2rA","userItemWrapper":"HER83"};